/**
 * Product Gallery Enhanced Zoom Modal
 * Features: Gallery navigation, video support, swipe-to-dismiss, body scroll lock
 * @requires jQuery, Swiper
 */

(function($) {
  'use strict';
  
  // Cache DOM elements
  const $zoomModal = $('#zoomModal');
  const $zoomModalContent = $('#zoomModalContent');
  const $zoomClose = $('#zoomClose');
  const $body = $('body');
  
  if (!$zoomModal.length) return;

  // State management
  let zoomSwiper = null;
  let touchState = {
    startY: 0,
    currentY: 0,
    isDragging: false
  };
  let scrollPosition = 0;

  /**
   * Initialize Zoom Swiper Gallery
   */
  function initZoomSwiper(startIndex = 0) {
    if (zoomSwiper) {
      zoomSwiper.slideTo(startIndex, 0);
      return;
    }

    zoomSwiper = new Swiper('.zoomSwiper', {
      loop: true,
      speed: 300,
      initialSlide: startIndex,
      navigation: {
        nextEl: '.zoom-swiper-next',
        prevEl: '.zoom-swiper-prev'
      },
      keyboard: { enabled: true },
      zoom: { maxRatio: 3 }, // Enable pinch-to-zoom in modal
      on: {
        slideChange: function() {
          handleSlideChange(this);
        }
      }
    });
  }

  /**
   * Handle slide change - manage video playback
   */
  function handleSlideChange(swiper) {
    const $activeSlide = $(swiper.slides[swiper.activeIndex]);
    const $activeVideo = $activeSlide.find('video');
    
    // Play active video
    if ($activeVideo.length) {
      $activeVideo.prop({ muted: true, loop: true });
      $activeVideo[0].play().catch(() => {});
    }
    
    // Pause inactive videos
    $(swiper.slides).each(function(idx) {
      if (idx !== swiper.activeIndex) {
        $(this).find('video').each(function() {
          this.pause();
        });
      }
    });
  }

  /**
   * Lock body scroll
   */
  function lockBodyScroll() {
    scrollPosition = $(window).scrollTop();
    $body.css({
      overflow: 'hidden',
      position: 'fixed',
      width: '100%',
      top: -scrollPosition
    });
  }

  /**
   * Unlock body scroll
   */
  function unlockBodyScroll() {
    $body.css({
      overflow: '',
      position: '',
      width: '',
      top: ''
    });
    $(window).scrollTop(scrollPosition);
  }

  /**
   * Open zoom modal
   */
  function openZoomModal(startIndex = 0) {
    lockBodyScroll();
    $zoomModal.removeClass('hidden').addClass('flex');
    initZoomSwiper(startIndex);
    
    // Delayed video play for active slide
    setTimeout(() => {
      if (zoomSwiper) {
        const $activeSlide = $(zoomSwiper.slides[zoomSwiper.activeIndex]);
        const $video = $activeSlide.find('video');
        
        if ($video.length) {
          $video.prop({ muted: true, loop: true });
          $video[0].play().catch(() => {});
        }
      }
    }, 100);
  }

  /**
   * Close zoom modal
   */
  function closeZoomModal() {
    unlockBodyScroll();
    $zoomModal.addClass('hidden').removeClass('flex');
    $zoomModalContent.css({ transform: '', opacity: '' });
    $zoomModal.css('backgroundColor', '');
    
    // Pause all videos
    if (zoomSwiper) {
      $(zoomSwiper.slides).find('video').each(function() {
        this.pause();
      });
    }
  }

  /**
   * Handle touch start for swipe-to-dismiss
   */
  function handleTouchStart(e) {
    const $target = $(e.target);
    
    // Don't interfere with navigation buttons or close button
    if ($target.closest('.zoom-swiper-prev, .zoom-swiper-next, #zoomClose').length) {
      return;
    }
    
    // Close on background/slide tap, but not on image/video
    if (!$target.is('img, video') && ($target.closest('.swiper-slide').length || !$target.closest('.zoomSwiper').length)) {
      closeZoomModal();
      return;
    }
    
    touchState.startY = e.touches[0].clientY;
    touchState.isDragging = true;
  }

  /**
   * Handle touch move for swipe-to-dismiss
   */
  function handleTouchMove(e) {
    if (!touchState.isDragging) return;
    
    touchState.currentY = e.touches[0].clientY;
    const deltaY = touchState.currentY - touchState.startY;
    
    // Only allow downward swipes
    if (deltaY > 0) {
      e.preventDefault();
      
      const scale = Math.max(0.7, 1 - (deltaY / 1000));
      const opacity = Math.max(0.3, 1 - (deltaY / 500));
      
      $zoomModalContent.css({
        transform: `translateY(${deltaY}px) scale(${scale})`,
        opacity: opacity
      });
      
      $zoomModal.css('backgroundColor', `rgba(0, 0, 0, ${0.9 * opacity})`);
    }
  }

  /**
   * Handle touch end for swipe-to-dismiss
   */
  function handleTouchEnd() {
    if (!touchState.isDragging) return;
    
    const deltaY = touchState.currentY - touchState.startY;
    
    // Close if swiped down more than 100px
    if (deltaY > 100) {
      closeZoomModal();
    } else {
      // Reset position
      $zoomModalContent.css({ transform: '', opacity: '' });
      $zoomModal.css('backgroundColor', '');
    }
    
    // Reset touch state
    touchState = {
      startY: 0,
      currentY: 0,
      isDragging: false
    };
  }

  /**
   * Initialize video loop fix
   */
  function initVideoLoopFix() {
    $('.product-video video, .zoom-modal-video video').each(function() {
      const video = this;
      
      $(video).on('ended', function() {
        if (this.hasAttribute('loop')) {
          this.currentTime = 0;
          this.play().catch(() => {});
        }
      });
      
      // Ensure autoplay videos start playing
      if (video.hasAttribute('loop') && video.hasAttribute('autoplay')) {
        video.play().catch(() => {});
      }
    });
  }

  /**
   * Event Bindings
   */
  
  // Close button
  $zoomClose.on('click', closeZoomModal);
  
  // Click on modal background or slide area to close
  $zoomModal.on('click', function(e) {
    const $target = $(e.target);
    
    // Don't close if clicking on navigation arrows, close button, or images/videos
    if ($target.closest('.zoom-swiper-prev, .zoom-swiper-next, #zoomClose').length) {
      return;
    }
    
    // Don't close if clicking directly on image or video
    if ($target.is('img, video')) {
      return;
    }
    
    // Close if clicking on swiper-slide or background
    if ($target.closest('.swiper-slide').length || $target.is('#zoomModal, #zoomModalContent')) {
      closeZoomModal();
    }
  });
  
  // Touch events for swipe-to-dismiss
  $zoomModalContent[0].addEventListener('touchstart', handleTouchStart, { passive: false });
  $zoomModalContent[0].addEventListener('touchmove', handleTouchMove, { passive: false });
  $zoomModalContent[0].addEventListener('touchend', handleTouchEnd);
  
  // Click on images/videos to open modal
  $(document).on('click', '.zoom-clickable', function(e) {
    e.preventDefault();
    e.stopPropagation();
    
    const mediaIndex = parseInt($(this).data('media-index') || 0);
    openZoomModal(mediaIndex);
  });

  $('.zoom-trigger').click(function(e) {
    e.preventDefault();
    e.stopPropagation();
  
    const mediaIndex = parseInt($(this).closest('.swiper-slide').find('.zoom-clickable').data('media-index') || 0);
      console.log(mediaIndex)
    openZoomModal(mediaIndex);
  });
  
  // Keyboard support
  $(document).on('keydown', function(e) {
    if ($zoomModal.hasClass('flex') && e.key === 'Escape') {
      closeZoomModal();
    }
  });
  
  // Initialize on document ready
  $(document).ready(function() {
    initVideoLoopFix();
  });

})(jQuery);

